precision highp float;

varying vec4 fragColor;

void main() {
	gl_FragColor = fragColor;
}